export class Constants {
  public static readonly NGB_INITIAL_PAGE:number = 1;
  public static readonly NGB_MAX_PAGES:number = 5;
  public static readonly PAGE_SIZE:number = 10;
  public static readonly PAGE_SIZE_EXCHANGE: number = 50;

  // Polling de jobs asincrónicos (/core/portal/jobs/{jobId}/status).
  // Ventana total de espera = intervalo * intentos (hoy 60 s). Ajustar según p50/p95 del servicio de IA.
  public static readonly JOB_POLLING_INTERVAL_MS: number = 3000;
  public static readonly JOB_POLLING_MAX_ATTEMPTS: number = 20;

  // Solicitud de financiamiento — Bloque 1 (monto solicitado)
  public static readonly FINANCING_MIN_AMOUNT: number = 10000000;
  public static readonly FINANCING_MAX_AMOUNT: number = 1000000000;
  // CA1: step base (1x) del slider; cada chip lo multiplica (2x, 3x, 5x, 10x). PRD: "a definir".
  public static readonly FINANCING_AMOUNT_BASE_STEP: number = 100000;
  public static readonly FINANCING_AMOUNT_MULTIPLIERS: number[] = [1, 2, 3, 5, 10];

  // Solicitud de financiamiento — Bloque 2 (último balance)
  // CA5b: antigüedad máxima del cierre para considerar un balance vigente.
  public static readonly BALANCE_VALIDITY_MONTHS: number = 24;
  // PROVISORIO: hasta que el backend devuelva el período de cierre, se estima como createdDate − N meses.
  public static readonly BALANCE_ESTIMATED_CLOSING_OFFSET_MONTHS: number = 6;
  // CA9 / CA12: por debajo de esta confianza el período detectado se trata como "baja confianza"
  // (el usuario lo confirma y el documento queda para validación manual). PRD: "a definir, parametrizable".
  public static readonly BALANCE_MIN_CONFIDENCE: number = 0.8;
  // CA7: formatos y peso máximo (default operativo hasta tener la configuración de documentos).
  public static readonly BALANCE_ALLOWED_EXTENSIONS: string[] = ['pdf'];
  public static readonly BALANCE_MAX_FILE_SIZE_MB: number = 10;
  // CA10: espera antes de guardar la fecha de cierre (junta cambios seguidos de mes y año en un solo llamado).
  public static readonly BALANCE_CLOSING_DATE_SAVE_DEBOUNCE_MS: number = 600;

  // Solicitud de financiamiento — Bloque 3 (ventas posteriores al balance)
  // CA24: máximo de renglones de ventas.
  public static readonly DECLARED_SALES_MAX_ROWS: number = 24;
  // Persona física (sin balance): cantidad de meses cerrados a declarar.
  public static readonly SALES_MONTHS_WITHOUT_BALANCE: number = 6;
  public static readonly DECLARED_SALES_CURRENCY: string = 'ARS';

  // Solicitud de financiamiento — Bloque 4 (CA30). Requiere aprobación de Legales.
  public static readonly DECLARED_VALUES_DISCLAIMER: string =
    'Los montos informados son declarados por la empresa y de carácter aproximado. ' +
    'Podrán ser validados con documentación respaldatoria si el inversor lo solicita.';

  public static DELAY = (time) => {
    return new Promise(res => {
      setTimeout(res,time)
    })
  }
}
